export const bankTransactionFields = {
  Bank: "Bank",
  AccountHolder: "Account holder",
  IBAN: "IBAN",
  TransactionReference: "Transaction reference",
  OpeningBalance: "Opening balance",
  Debit: "Debit",
  Credit: "Credit",
  ClosingBalance: "Closing balance",
  TransactionDate: "Transaction date",
  SyncDate: "Sync date",
};
